import { Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0C2340] border-t border-white/10 py-12 px-4 sm:px-8">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex items-center gap-2.5">
          <span className="w-10 h-10 rounded-lg bg-white p-1 flex items-center justify-center">
            <img src="/images/logo.png" alt="Davao Memorial Park logo" className="w-full h-full object-contain" />
          </span>
          <div>
            <p className="font-display text-lg font-semibold text-white leading-none">Davao Memorial Park</p>
            <p className="text-white/50 text-xs mt-1 italic">Where yesterdays are remembered for many tomorrows</p>
          </div>
        </div>

        <nav className="flex flex-wrap justify-center gap-6 text-sm">
          <a href="#about" data-testid="footer-link-about" className="text-white/70 hover:text-[#C59B27] transition-colors">About</a>
          <a href="#columbarium" data-testid="footer-link-columbarium" className="text-white/70 hover:text-[#C59B27] transition-colors">Columbarium</a>
          <a href="#inquire" data-testid="footer-link-inquire" className="text-white/70 hover:text-[#C59B27] transition-colors">Inquire</a>
          <a href="#contact" data-testid="footer-link-contact" className="text-white/70 hover:text-[#C59B27] transition-colors">Contact</a>
          <a
            href="https://www.facebook.com/DavaoMemorialPark"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook-link"
            className="inline-flex items-center gap-1.5 text-white/70 hover:text-[#C59B27] transition-colors"
          >
            <Facebook className="w-4 h-4" /> Facebook
          </a>
        </nav>

        <p className="text-white/40 text-xs text-center">
          © 2026 Davao Memorial Park (DMPI). All rights reserved.
        </p>
      </div>
    </footer>
  );
}
